import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import iview from 'iview'
import 'iview/dist/styles/iview.css'
import scroll from 'vue-seamless-scroll'

Vue.use(scroll);
Vue.use(iview);
Vue.config.productionTip = false


// 引入 Froala Editor js file.
require('froala-editor/js/froala_editor.pkgd.min')

//引入中文语言包
require('froala-editor/js/languages/zh_cn')

//引入 Froala Editor css files.
require('froala-editor/css/froala_editor.pkgd.min.css')
require('font-awesome/css/font-awesome.css')//此处可在index.html中引入：font-awesome cdn地址：<link href="https://cdn.bootcss.com/font-awesome/4.7.0/css/font-awesome.min.css" rel="stylesheet">
require('froala-editor/css/froala_style.min.css')

// Import and use Vue Froala lib.
import VueFroala from 'vue-froala-wysiwyg'
import axios from "axios";
import {Decrypt} from "../common/tool";

// http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response && response.data && response.data.data) {
            response.data.data = JSON.parse(Decrypt(response.data.data))
        }
        return response;
    },
    error => {
        return Promise.reject();
    });

Vue.use(VueFroala);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')


